<template>
  <button
    class="color-button p-2 border border-secondary-20 flex items-center rounded-lg
    justify-center relative"
    :class="{ 'active': active }"
    @click="handleClick"
    type="button"
    :aria-label="`Select color ${color}`"
  >
    <span
      class="w-6 h-6 border border-secondary-20 rounded-full"
      :style="{ backgroundColor: color }"
    ></span>
  </button>
</template>

<script>
export default {
  name: 'ColorButton',
  props: {
    color: {
      type: String,
      required: true,
      default: '#000000',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick() {
      this.$emit('color-selected', this.color)
    },
  },
}
</script>

<style scoped>
.color-button:hover {
  @apply border-primary-90;
}

.color-button:focus-visible {
  @apply border-2 border-primary-80;
  outline: none;
}

.color-button.active {
  @apply border-2 border-primary-90;
}
</style>
